import React from "react"
import { AppFunctionComponent, TextBuilder } from "../../../types"
import { PromoBarContainer } from "./promo-bar.styled"
import Section from "../../../components/common/sections/section.component"
import RichText from "../../../resolvers/rich-text/rich-text.resolver"

type Props = {
  content?: TextBuilder
}

const PromoBar: AppFunctionComponent<Props> = ({ content }) => {
  const { text } = content!

  return (
    <>
      {text && (
        <PromoBarContainer>
          <Section>
            <RichText content={text} />
          </Section>
        </PromoBarContainer>
      )}
    </>
  )
}

export default PromoBar
